export var view_seccion = {
  // Login
  login: 'login',
  // Reportes
  ejecuciones: 'Ejecuciones',
  binarios: 'Binarios',
  reportes_de_almacenistas: 'Reportes de almacenistas',
  reportes_de_cedis: 'Reportes de cedis',
  // Datos
  cedis: 'CEDIS',
  categorias: 'Conceptos',
  sub_categorias: 'Evaluar',
  evaluaciones: 'Evaluaciones',
  almacenistsas: 'Almacenistas',
  clientes: 'Clientes',
  evaluadores: 'Evaluadores',
  oficinas_de_ventas: 'Oficinas de ventas',
  areas_de_ventas: 'Areas de ventas',
  almacenistas: 'Almacenistas',
}
